import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Modal from 'LuxKit/Modal/Modal'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import useModalElementContext from 'hooks/Modal/useModalElementContext'
import getLoyaltyProgramDisplayName from 'loyalty/selectors/getLoyaltyProgramDisplayName'

const BulletList = styled.ul`
  margin: 0;
  padding-left: ${rem(21)};
`

function LoyaltyBurnInfoModal() {
  const intl = useIntl()
  const { resolve } = useModalElementContext()

  const title = intl.formatMessage(
    {
      id: '36aMe8RySRR1xpypHG2l',
      defaultMessage: 'Using your {programName} points',
      description: 'Title heading for the loyalty program points information modal overlay',
    },
    { programName: getLoyaltyProgramDisplayName() },
  )

  return <Modal
    title={title}
    onClose={() => resolve()}
  >
    <Group gap={20} direction="vertical">
      <BodyText variant="medium" colour="neutral-two">
        <FormattedMessage
          id="vmlu6T3Y-fXZJHo_3OfI"
          defaultMessage="{programName} points are earned on every booking you make with us — the more you travel, the more you accumulate. When you're ready to use them, they come straight off the price of your next escape."
          description="Body text for the loyalty program points information modal explaining how points are earned and redeemed"
          values={{ programName: getLoyaltyProgramDisplayName() }}
        />
      </BodyText>
      <BulletList>
        <li>
          <BodyText variant="medium" colour="neutral-two">
            <FormattedMessage
              id="6cbxdDOv-Rgu0glv6O-G"
              defaultMessage="You need at least 1,000 points to start redeeming"
              description="Société points info modal bullet explaining minimum points required to redeem"
            />
          </BodyText>
        </li>
        <li>
          <BodyText variant="medium" colour="neutral-two">
            <FormattedMessage
              id="pFcJ1MIWG4tNyN9L-gUA"
              defaultMessage="Use all your points, or mix them with cash — it's up to you"
              description="Société points info modal bullet explaining mixing points with cash payment"
            />
          </BodyText>
        </li>
        <li>
          <BodyText variant="medium" colour="neutral-two">
            <FormattedMessage
              id="Y5Pz1xaPw5Uy5BJ2vGKc"
              defaultMessage="At checkout, use the slider to choose exactly how many points to apply"
              description="Société points info modal - checkout slider bullet"
            />
          </BodyText>
        </li>
        <li>
          <BodyText variant="medium" colour="neutral-two">
            <FormattedMessage
              id="5BPvqdQH_9H2xa2ZFPtF"
              defaultMessage="Points can be used across hotels, tours, cruises, flights and more"
              description="Société points info modal - usage across verticals bullet"
            />
          </BodyText>
        </li>
      </BulletList>
    </Group>
  </Modal>
}

export default LoyaltyBurnInfoModal
